'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--GraduationCap';

var EntypoGraduationCap = function EntypoGraduationCap(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M3.302,12.238c0.464,1.879,1.054,2.701,3.022,3.562C8.293,16.66,9.228,17.6,10,17.6c0.771,0,1.648-0.822,3.616-1.684c1.969-0.861,1.443-1.123,1.907-3.002L10,15.6L3.302,12.238z M19.511,7.336l-8.325-4.662c-0.652-0.365-1.72-0.365-2.372,0L0.488,7.336c-0.652,0.365-0.652,0.963,0,1.328l8.325,4.662c0.652,0.365,1.72,0.365,2.372,0l5.382-3.014l-5.836-1.367C10.506,9,10.259,9.031,10,9.031c-1.052,0-1.904-0.506-1.904-1.131c0-0.627,0.853-1.133,1.904-1.133c0.816,0,1.51,0.307,1.78,0.734l6.182,2.029l1.549-0.867C20.162,8.299,20.162,7.701,19.511,7.336z M16.967,16.17c-0.065,0.385,1.283,1.018,1.411-0.107c0.579-5.072-0.416-6.531-0.416-6.531l-1.395,0.781C16.567,10.312,17.75,11.438,16.967,16.17z' })
    );
};

exports.default = EntypoGraduationCap;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/GraduationCap.js
// module id = ./node_modules/react-entypo/lib/entypo/GraduationCap.js
// module chunks = 2